import { getProgramVersion } from './program-version.js';

export function diffPrograms(oldProgram, newProgram) {
  if (!oldProgram) {
    return {
      versionChanged: true,
      newMediaUrls: extractMediaUrls(newProgram),
      removedMediaUrls: [],
    };
  }
  if (getProgramVersion(oldProgram) === getProgramVersion(newProgram)) {
    return { versionChanged: false, newMediaUrls: [], removedMediaUrls: [] };
  }
  const oldUrls = new Set(extractMediaUrls(oldProgram));
  const newUrls = new Set(extractMediaUrls(newProgram));
  return {
    versionChanged: true,
    newMediaUrls: [...newUrls].filter((u) => !oldUrls.has(u)),
    removedMediaUrls: [...oldUrls].filter((u) => !newUrls.has(u)),
  };
}

export function extractMediaUrls(program) {
  if (!program?.slots) return [];
  const urls = [];
  for (const slot of program.slots) {
    if (slot.mediaUrl) urls.push(slot.mediaUrl);
  }
  return urls;
}
